import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";
import { syncProviderTags } from "./syncProviderTags";

export function useUpdateProviderTags() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: ({ providerId, tagIds }: { providerId: string; tagIds: string[] }) =>
      syncProviderTags(providerId, tagIds),
    onSuccess: (_, { providerId }) => {
      queryClient.invalidateQueries({ queryKey: keys.getProviderById(providerId) });
      if (currentSpace?.id) {
        queryClient.invalidateQueries({ queryKey: keys.getProvidersList(currentSpace.id) });
      }
    },
  });
}

